import React, { useCallback, useEffect, useState } from 'react';
import { ShieldCheckIcon, ArrowRightIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/trackAddToCart';
const CART_URL = 'https://mujeresempoderadas.lat/cart/add?id=52459756126507&quantity=1';
const CAROUSEL_IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/acuT3CjoXgkxBzn1nkm6Xr/20260304_1812_Refrigerador_Organizado_y_Abundante_simple_compose_01kjxb41q8e2v812caj67jcyd7.png',
  alt: 'Refrigerador organizado con comidas preparadas y etiquetadas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/v7Xi78DZ6qCgRYbLPQaepQ/20260304_1812_Image_Generation_simple_compose_01kjxb385xf5w93798mr0110qj.png',
  alt: 'Comidas preparadas con planificador semanal'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/dDKJpWNxYaVRaV6dLw18mV/20260304_1810_Image_Generation_simple_compose_01kjxazq1df5d88qj921zn311d.png',
  alt: 'Cocina en acción — preparación de comidas por bloques'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/fCTa489kPrLY9BBk6r6uAW/20260304_1809_Image_Generation_simple_compose_01kjxaynzfft4vzj8qw0qx7knt.png',
  alt: 'Freezer organizado con porciones etiquetadas y fechadas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vSmC6mUKwVhd3CnqZCSPr5/20260304_1809_Image_Generation_simple_compose_01kjxaxt63entb7gckwskac2m7.png',
  alt: 'Variedad de comidas preparadas listas para la semana'
}];
export function HeroSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const goToSlide = useCallback((index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex(index);
    setTimeout(() => setIsTransitioning(false), 500);
  }, [isTransitioning]);
  const goNext = useCallback(() => {
    goToSlide((currentIndex + 1) % CAROUSEL_IMAGES.length);
  }, [currentIndex, goToSlide]);
  const goPrev = useCallback(() => {
    goToSlide((currentIndex - 1 + CAROUSEL_IMAGES.length) % CAROUSEL_IMAGES.length);
  }, [currentIndex, goToSlide]);
  // Auto-advance every 3.5 seconds
  useEffect(() => {
    const timer = setInterval(goNext, 3500);
    return () => clearInterval(timer);
  }, [goNext]);
  return <section className="w-full overflow-hidden" style={{
    background: 'var(--bg-warm)'
  }} aria-label="Hero" data-id="element-145">
      <div className="max-w-2xl mx-auto px-4 pt-10 pb-12 md:pt-16 md:pb-20" data-id="element-146">
        <div className="flex flex-col items-center text-center" data-id="element-147">
          {/* Trust badges */}
          <div className="flex flex-wrap items-center justify-center gap-2 mb-5" data-id="element-148">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold" style={{
            background: 'var(--color-accent-light)',
            color: 'var(--color-accent)',
            border: '1px solid rgba(58,107,60,0.2)',
            fontFamily: 'var(--font-body)',
            letterSpacing: '0.02em'
          }} data-id="element-149">
              ✅ Compra Verificada
            </span>
            <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold" style={{
            background: 'var(--color-gold-light)',
            color: '#7A5C10',
            border: '1px solid rgba(184,146,42,0.25)',
            fontFamily: 'var(--font-body)',
            letterSpacing: '0.02em'
          }} data-id="element-150">
              ★★★★★
              <span className="ml-1" data-id="element-151">+500 familias</span>
            </span>
          </div>

          {/* Main headline */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl mb-4" style={{
          fontFamily: 'var(--font-heading)',
          fontWeight: 600,
          color: 'var(--text-primary)',
          letterSpacing: '-0.02em',
          lineHeight: 1.1
        }} data-id="element-152">
            Resolvé{' '}
            <span style={{
            color: 'var(--color-gold)'
          }} data-id="element-153">
              10 Días de Comida
            </span>{' '}
            en Solo{' '}
            <span style={{
            color: 'var(--color-gold)'
          }} data-id="element-154">
              2 Horas
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-base md:text-lg mb-7" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--text-secondary)',
          lineHeight: 1.75,
          fontWeight: 400,
          maxWidth: '520px'
        }} data-id="element-155">
            <em className="font-[400]" data-id="element-156">
              El{' '}
              <strong style={{
              fontWeight: 700,
              textDecoration: 'underline',
              textDecorationColor: 'var(--color-gold)',
              textUnderlineOffset: '3px',
              textDecorationThickness: '2px'
            }} data-id="element-157">
                sistema de 6 pasos
              </strong>{' '}
              para dejar de improvisar, eliminar el delivery por cansancio y
              tener el freezer lleno
            </em>{' '}
            —{' '}
            <strong style={{
            color: 'var(--text-primary)',
            fontWeight: 600
          }} data-id="element-158">
              sin vivir en la cocina.
            </strong>
          </p>

          {/* Hero Carousel */}
          <div className="w-full rounded-2xl overflow-hidden mb-8 relative group" style={{
          border: '1px solid var(--border-default)',
          boxShadow: 'var(--shadow-md)'
        }} aria-label="Galería de imágenes del Sistema 10x2™" role="region" data-id="element-159">
            {/* Images container */}
            <div className="relative w-full overflow-hidden" style={{
            aspectRatio: '4/3'
          }} data-id="element-160">
              {CAROUSEL_IMAGES.map((image, index) => <img key={index} src={image.src} alt={image.alt} className="absolute inset-0 w-full h-full object-cover" style={{
              opacity: currentIndex === index ? 1 : 0,
              transition: 'opacity 0.5s ease-in-out',
              zIndex: currentIndex === index ? 1 : 0
            }} data-id="element-161" />)}
            </div>

            {/* Navigation arrows */}
            <button onClick={goPrev} className="absolute left-2 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200" style={{
            background: 'rgba(0,0,0,0.45)',
            backdropFilter: 'blur(4px)',
            border: 'none',
            cursor: 'pointer'
          }} aria-label="Imagen anterior" data-id="element-162">
              <ChevronLeftIcon className="w-5 h-5 text-white" data-id="element-163" />
            </button>
            <button onClick={goNext} className="absolute right-2 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200" style={{
            background: 'rgba(0,0,0,0.45)',
            backdropFilter: 'blur(4px)',
            border: 'none',
            cursor: 'pointer'
          }} aria-label="Imagen siguiente" data-id="element-164">
              <ChevronRightIcon className="w-5 h-5 text-white" data-id="element-165" />
            </button>

            {/* Dot indicators */}
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 z-10 flex items-center gap-1.5" data-id="element-166">
              {CAROUSEL_IMAGES.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className="rounded-full transition-all duration-300" style={{
              width: currentIndex === index ? '20px' : '8px',
              height: '8px',
              background: currentIndex === index ? 'white' : 'rgba(255,255,255,0.5)',
              border: 'none',
              cursor: 'pointer',
              padding: 0
            }} aria-label={`Ir a imagen ${index + 1}`} aria-current={currentIndex === index ? 'true' : undefined} data-id="element-167" />)}
            </div>
          </div>

          {/* Stats row */}
          <div className="flex flex-nowrap justify-center gap-2 sm:gap-3 mb-7 w-full" data-id="element-168">
            <div className="flex flex-col items-center px-3 sm:px-4 py-3 rounded-xl flex-1 min-w-0" style={{
            background: 'var(--bg-surface)',
            border: '1px solid var(--border-default)',
            boxShadow: 'var(--shadow-sm)'
          }} data-id="element-169">
              <span className="font-bold leading-none" style={{
              fontFamily: 'var(--font-heading)',
              color: 'var(--color-primary)',
              fontSize: '1.75rem'
            }} data-id="element-170">
                4
              </span>
              <span className="text-[10px] sm:text-xs mt-1 text-center leading-tight" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-muted)',
              fontWeight: 500
            }} data-id="element-171">
                Recetas Estratégicas
              </span>
            </div>
            <div className="flex flex-col items-center px-3 sm:px-4 py-3 rounded-xl flex-1 min-w-0" style={{
            background: 'var(--bg-surface)',
            border: '1px solid var(--border-default)',
            boxShadow: 'var(--shadow-sm)'
          }} data-id="element-172">
              <span className="font-bold leading-none" style={{
              fontFamily: 'var(--font-heading)',
              color: 'var(--color-primary)',
              fontSize: '1.75rem'
            }} data-id="element-173">
                20
              </span>
              <span className="text-[10px] sm:text-xs mt-1 text-center leading-tight" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-muted)',
              fontWeight: 500
            }} data-id="element-174">
                Porciones Listas
              </span>
            </div>
            <div className="flex flex-col items-center px-3 sm:px-4 py-3 rounded-xl flex-1 min-w-0" style={{
            background: 'var(--bg-surface)',
            border: '1px solid var(--border-default)',
            boxShadow: 'var(--shadow-sm)'
          }} data-id="element-175">
              <span className="font-bold leading-none" style={{
              fontFamily: 'var(--font-heading)',
              color: 'var(--color-primary)',
              fontSize: '1.75rem'
            }} data-id="element-176">
                2 hs
              </span>
              <span className="text-[10px] sm:text-xs mt-1 text-center leading-tight" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-muted)',
              fontWeight: 500
            }} data-id="element-177">
                De Cocina
              </span>
            </div>
            <div className="flex flex-col items-center px-3 sm:px-4 py-3 rounded-xl flex-1 min-w-0" style={{
            background: 'var(--bg-surface)',
            border: '1px solid var(--border-default)',
            boxShadow: 'var(--shadow-sm)'
          }} data-id="element-178">
              <span className="font-bold leading-none" style={{
              fontFamily: 'var(--font-heading)',
              color: 'var(--color-primary)',
              fontSize: '1.75rem'
            }} data-id="element-179">
                10
              </span>
              <span className="text-[10px] sm:text-xs mt-1 text-center leading-tight" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-muted)',
              fontWeight: 500
            }} data-id="element-180">
                Días Resueltos
              </span>
            </div>
          </div>

          {/* CTA */}
          <a href={CART_URL} onClick={trackAddToCart} className="btn-cta btn-cta-pulse w-full text-base md:text-lg px-8 py-4 mb-4 rounded-xl flex justify-center" aria-label="Quiero mi sistema" data-id="element-181">
            QUIERO MI SISTEMA
            <ArrowRightIcon className="w-5 h-5 flex-shrink-0" data-id="element-182" />
          </a>

          {/* Micro-trust */}
          <p className="flex items-center justify-center gap-1.5 text-sm" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--text-muted)',
          fontWeight: 400
        }} data-id="element-183">
            <ShieldCheckIcon className="w-4 h-4 flex-shrink-0" style={{
            color: 'var(--color-accent)'
          }} data-id="element-184" />
            Pago único · Acceso inmediato · Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}